import is from "is_js";

export const isBrowserSupported = () => {
  return is.ie(">=11") || is.edge(">=16") || is.firefox(">=60") || is.chrome(">=55") || is.safari(">=11");
};



// WEBPACK FOOTER //
// ./src/helpers/browserHelpers.js